import DOCUMENTATION_PRODUCT_NAME from 'utilities/uTagging';
import { ORIGIN_BY_CHANNEL } from 'constants/uTagConstants/origin';
import { OTP_TRANSFER_VIEW, DOCUMENTATION_VIEW } from 'constants/steps';
import { PATH_DOCUMENTATION_FINISHED } from 'constants/uTagConstants/paths';
import { PROCESS_TYPE_ONBOARDING } from 'utilities/uTagConstants';
import { TRANSFER_OTP_PATH, TRANSFER_OTP_PATH_STEP } from 'constants/uTagConstants/paths';
import { recordPage, RELIABLE, recordEvent, recordEventStepSuccess } from 'utilities/uTagging';
import cryptoJS from 'crypto-js';

export const doTagShowHelpModal = () =>
    recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
        accionEvento: 'otp-ibanid/modal-te-ayudamos',
        etiquetaEvento: 'vista',
        categoriaEvento: 'eventos IBAN OTP',
    });

export const doTagToggleAlternativeOptionModal = investmentType =>
    recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
        accionEvento: 'otp-ibanid/modal-espera-transferencia',
        etiquetaEvento: 'vista',
        categoriaEvento: 'eventos IBAN OTP',
        event_name: 'step_standby',
        pageName: '/onboarding/step10/standby',
        sectionFamily: 'banking',
        sectionCategory: 'onboarding',
        sectionName: 'userOnboarding',
        interactionType: 'funnel',
        serviceType: 'onboarding',
        processType: 'onboarding',
        processStep: 'step10',
        processDetail: 'standby',
        onboardingType: investmentType,
    });

export const doTagCheckBoxAlternativeOption = tagEvent =>
    recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
        accionEvento: 'otp-ibanid',
        etiquetaEvento: tagEvent,
        categoriaEvento: 'eventos IBAN OTP',
    });

export const doTagOnPageReload = ({
    encryptedDocNumber,
    identityMethod,
    investmentType,
    jointHolderInfo,
    product,
    productsDescription,
    promoCode,
    recordId,
    userId,
}) =>
    recordPage(
        TRANSFER_OTP_PATH,
        recordId,
        userId,
        product,
        productsDescription,
        promoCode ? promoCode : '',
        jointHolderInfo,
        RELIABLE[identityMethod],
        '',
        investmentType,
        {
            identificadorOnboarding: encryptedDocNumber,
            tipoProceso: PROCESS_TYPE_ONBOARDING,
            pasoProceso: TRANSFER_OTP_PATH_STEP,
            detalleProceso: '',
            nombreProducto: DOCUMENTATION_PRODUCT_NAME,
            event_name: 'step_otp',
            pageName: '/onboarding/step9/otp',
            sectionFamily: 'banking',
            sectionCategory: 'onboarding',
            sectionName: 'userOnboarding',
            interactionType: 'funnel',
            serviceType: 'onboarding',
            processType: 'onboarding',
            processStep: 'step9',
            processDetail: 'otp',
            onboardingType: investmentType,
        }
    );

export const doTagContinueButton = () =>
    recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
        accionEvento: 'otp-ibanid',
        etiquetaEvento: 'continuar',
        categoriaEvento: 'eventos IBAN OTP',
    });

export const doTagSuccessfulEvent = investmentType =>
    recordEventStepSuccess(investmentType, '/onboarding/documentacion/ibanid', 'verificacion seguridad', {
        event_name: 'event_success',
        action: 'success',
        format: 'steps',
        component: 'funnel',
        element: 'otp',
    });

export const doTagCheckAndRecordWhichTagForSuccessStatus = ({
    jointHolderInfo,
    channel,
    clientRisk,
    docNumber,
    documentationStatusCounter,
    identityMethod,
    immStepsState,
    investmentType,
    product,
    products,
    promoCode,
    recordId,
    userId,
}) => {
    const currentStep = immStepsState.get('steps').getIn([immStepsState.get('currentStep')]);

    const POSSIBLE_PATHS = {
        [DOCUMENTATION_VIEW]: { path: PATH_DOCUMENTATION_FINISHED, detalleProceso: 'finalizado' },
        [OTP_TRANSFER_VIEW]: { path: PATH_DOCUMENTATION_FINISHED, detalleProceso: 'finalizado-otp' },
    };

    recordPage(
        POSSIBLE_PATHS[currentStep.toJS().stepName].path,
        recordId,
        userId,
        product,
        products.get('productsDescription'),
        promoCode ? promoCode : '',
        jointHolderInfo,
        RELIABLE[identityMethod],
        '',
        investmentType,
        {
            tipoProceso: PROCESS_TYPE_ONBOARDING,
            pasoProceso: 'documentacion',
            detalleProceso: POSSIBLE_PATHS[currentStep.toJS().stepName].detalleProceso,
            onboardingContFinal: documentationStatusCounter > 0 ? 2 : 1,
            onboardingR: clientRisk || '',
            onboardingIdMethod: RELIABLE[identityMethod],
            devId: '1taggingDocumentation',
            nombreProducto: DOCUMENTATION_PRODUCT_NAME,
            identificadorOnboarding: docNumber ? cryptoJS.SHA256(docNumber).toString() : '',
            onboardingOrigin: ORIGIN_BY_CHANNEL[channel],
        }
    );
};
